import { HorizontalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DropdownMenuItemContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    isActive = false,
    isDisabled = false,
    onClick,
    testId = TEST_ID
}) => {
    const activeStyles = isActive ? styles.active : '';
    const disabledStyles = isDisabled ? styles.disabled : '';
    const handleClick = isDisabled ? undefined : onClick;

    return (
        <HorizontalContainer
            className={`${className} ${styles.dropdownMenuItemContainer} ${activeStyles} ${disabledStyles}`}
            onClick={handleClick}
            testId={testId}>
            {children}
        </HorizontalContainer>
    );
};

export default DropdownMenuItemContainer;
